import React from "react";
import { Container, Row, Col, Image, Button, Form } from "react-bootstrap";
import Header from "../components/header";
import Footer from "../components/footer";
import "../index.css";
import { useSendEmail } from "../hooks/useSendEmail";
import { getContactInfo } from "../data/contactData";
import trust from "../assets/images/trust2.png";
import github from "../assets/images/github.png";
import gmail from "../assets/images/gmail.png";
import linkedin from "../assets/images/linkedin.png";
import telegram from "../assets/images/telegram.png";
import whatsapp from "../assets/images/whatsapp.png";
import behance from "../assets/images/behance.png";
import khamsat from "../assets/images/khamsat-seeklogo.png"
import mostaql from "../assets/images/mostaql.jfif"
import freelancer from "../assets/images/freelancer-com-seeklogo.png"

function Contact() {
    const { form, sendEmail, status } = useSendEmail();
    const contactInfo = getContactInfo()

    return(
        <>

            <Header />

            <Container className="contact-container fade-in-up gap-3 mt-5">
                {/* HERO SECTION */}
                <Row className="d-flex align-items-center justify-content-center text-center">
                    <Col className="d-flex flex-column align-items-center justify-content-center text-center">
                        <h1 className="contact-title">Connect with me</h1>
                        <p>Let's collaborate and build something amazing together</p>
                        <Image
                            src={trust}
                            alt="Trust"
                            className="trust-img"
                        />
                    </Col>
                </Row>

                {/* CONTACT ROW */}
                <Row className="d-flex align-items-start justify-content-center mt-5 text-center text-lg-start contact-row">
                    {/* Left column - Social Icons */}
                    <Col sm={12} md={6} className="order-2 order-md-1 contact-left mb-4 d-flex flex-column align-items-center">
                        <h2 className="heading mb-4">Contact Me</h2>
                        <div className="icon-grid">
                            <a href={contactInfo?.email} className="social-icon" target="_blank" rel="noopener noreferrer">
                                <Image src={gmail} alt="Gmail"  />
                            </a>
                            <a href={contactInfo?.github} className="social-icon" target="_blank" rel="noopener noreferrer">
                                <Image src={github} alt="GitHub"  />
                            </a>
                            <a href={contactInfo?.linkedin} className="social-icon" target="_blank" rel="noopener noreferrer">
                                <Image src={linkedin} alt="LinkedIn"  />
                            </a>
                            <a href={contactInfo?.mostaql} className="social-icon" target="_blank" rel="noopener noreferrer">
                                <Image
                                    src={mostaql}
                                    alt="Mostaql"
                                    style={{
                                        // backgroundPosition: "left -125px",
                                        // height: "48px",
                                        // width: "48px"
                                    }}
                                />
                            </a>
                            <a href={contactInfo?.khamsat} className="social-icon" target="_blank" rel="noopener noreferrer">
                                <Image src={khamsat} alt="Khamsat" />
                            </a>
                            <a href={contactInfo?.freelancer} className="social-icon" target="_blank" rel="noopener noreferrer">
                                <Image src={freelancer} alt="Freelancer" />
                            </a>
                            <a href={contactInfo?.behance} className="social-icon" target="_blank" rel="noopener noreferrer">
                                <Image src={behance} alt="Behance"  />
                            </a>
                            <a href={contactInfo?.whatsapp} className="social-icon" target="_blank" rel="noopener noreferrer">
                                <Image src={whatsapp} alt="WhatsApp"  />
                            </a>
                            <a href={contactInfo?.telegram} className="social-icon" target="_blank" rel="noopener noreferrer">
                                <Image src={telegram} alt="Telegram"  />
                            </a>
                        </div>
                    </Col>

                    {/* Right column - Contact Form */}
                    <Col sm={12} md={6} className="order-1 order-md-2 contact-right mb-4">
                        <div className="contact-form-box p-4">
                            <h2 className="heading mb-3">Quick Message</h2>
                            <Form className="text-start" ref={form} onSubmit={sendEmail}>
                                <Form.Group className="mb-3" controlId="username">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control type="text" name="username" placeholder="ex: John Smith" required />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" name="email" placeholder="example@gmail.com" required />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="subject">
                                    <Form.Label>Subject</Form.Label>
                                    <Form.Control type="text" name="subject" placeholder="Enter email title" required />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="message">
                                    <Form.Label>Message</Form.Label>
                                    <Form.Control as="textarea" name="message" rows={4} placeholder="Write what you think of ..." required />
                                </Form.Group>
                                {status === "success" && (
                                    <div className="custom-alert custom-alert-success my-3 w-100 text-center">
                                        <span className="message p-0">Thanks for contacting me! I'll get back to you soon.</span>
                                    </div>
                                )}

                                {status === "error" && (
                                    <div className="custom-alert custom-alert-error my-3 w-100 text-center">
                                        <span className="message p-0">Oops! Something went wrong. Please try again later.</span>
                                    </div>
                                )}

                                <Button
                                    type="submit"
                                    className="send-btn w-100"
                                    disabled={status === "sending"}
                                >
                                    {status === "sending" ? "Sending..." : "Send"}
                                </Button>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>

            <Footer />
        </>
    );
}

export { Contact };
